import { Box, Heading, Text, type TextRef } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import useFocusOnNavigation from "../../../../hooks/useFocusOnNavigation";
import { CloseButton } from "../CloseButton";

import { useNavigation } from "@react-navigation/native";
import React, { useRef } from "react";
import { StyleSheet } from "react-native";

export function CompanySummaryDisclaimerModal() {
  const i18n = useI18n();
  const navigation = useNavigation();
  const titleRef = useRef<TextRef>(null);

  useFocusOnNavigation(titleRef);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Text ref={titleRef} sx={styles.headerTitle} accessible={true} accessibilityRole="header">
          <Heading level={3}>
            {i18n.pgettext("AI company summary disclaimer title", "About this summary")}
          </Heading>
        </Text>
        <CloseButton
          onPress={() => navigation.goBack()}
          accessibilityLabel={i18n.gettext("Close")}
        />
      </Box>
      <Box sx={styles.content}>
        <Text level={3}>
          {i18n.pgettext(
            "AI company summary disclaimer body",
            "This was generated by AI and may contain mistakes or outdated info. Check the Company Page for accuracy.",
          )}
        </Text>
      </Box>
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 8,
  },
  headerTitle: {
    flex: 1,
    paddingRight: 10,
  },
  content: {
    paddingTop: 8,
    paddingLeft: 16,
    paddingRight: 16,
  },
});
